<template>
  <HeroView/>
  <ThemesView/>
  <BenefitsView/>
  <FaqView/>
  <FinalView/>
</template>

<script>
import HeroView from '@/components/home/HeroView.vue'
import ThemesView from '@/components/home/ThemesView.vue'
import BenefitsView from '@/components/home/BenefitsView.vue'
import FaqView from '@/components/home/FaqView.vue'
import FinalView from '@/components/home/FinalView.vue'

export default {
  name: 'HomeView',
  components: {
    HeroView,
    ThemesView,
    BenefitsView,
    FaqView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: 'Creative Commerce – Sales-Optimized Shopify Themes',
  meta: [
    { name: 'description', content: 'Sales-optimized Shopify themes by Creative Commerce Labs, built for fast performance, flexible layouts, and high-converting, mobile-ready design.' },

    { property: 'og:title', content: 'Creative Commerce – Shopify Themes Designed to Sell More' },
    { property: 'og:description', content: 'Sales-optimized themes with fast performance, intuitive navigation, and conversion-driven design, built to accelerate store expansion and profits.' },
    { property: 'og:image', content: '/assets/imgs/og_image.png' },
    { property: 'og:url', content: 'https://creativecommercelabs.com/' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Creative Commerce' }
  ]
})
</script>
